<template>
  <div class="nominations" id="reportVEAwards">
    <ul class="list-group mb-4">
      <li v-for="nomination in nominations" v-bind:key="nomination.id" class="list-group-item mb-4">
        <div class="d-sm-flex pt-2">
          <figure>
           <img class="border border-secondary rounded" src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/06/generic-profile.png" width="120" height="120">
            <figcaption class="text-center small pt-1 font-weight-bold">
              {{nomination.equity_nominee_name[0]}}
            </figcaption>
          </figure>
          <div class="pl-sm-4">
            <img class="float-right" :src="'static/' + nomination.author_country + '.svg'" width="50" height="33">
            <h4 v-html="nomination.title.rendered"></h4>
            <ul class="list-inline">
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-user fa-fw"></i>
                  Nomination by:
                  <router-link :to="'/thinktank-user/' + nomination._embedded.author[0].slug" target="_blank">{{nomination._embedded.author[0].name}}</router-link>
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-address-card fa-fw"></i>
                  Staff no. {{nomination.equity_nominator_employee_number}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-building fa-fw"></i>
                  {{nomination.equity_nominator_employee_number}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-clock fa-fw"></i>
                  {{nomination.date.substring(0, 10)}}
                </small>
              </li>
            </ul>
            <hr>
            <div v-html="nomination.content.rendered"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: [
    'nominations'
  ],
  data () {
    return {
      nominationsWithCountry: []
    }
  },
  created () {
    this.nominationsWithCountry = this.nominations
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EquityReportEntries.vue